














import Vue from "vue";
import * as routes from "@/router/routes";

// Vue components
import StandardPage from "@/components/PageTemplates/StandardPage.vue";
import CaosUserSyncMainTable from "./CaosUserSyncMainTable.vue";

// Model
import { dataTableItemsPerPage } from "@/utility/Constants";
import { FetchInstallationsCaosUserSyncConfigurationResData } from "@/model/communication/caosConfiguration/FetchInstallationsCaosUserSyncConfigurationResData";
import { FetchInstallationsCaosUserSyncConfigurationCommand } from "@/model/communication/caosConfiguration/FetchInstallationsCaosUserSyncConfigurationCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";

export default Vue.extend({
    components: {
        StandardPage,
        CaosUserSyncMainTable,
    },
    data() {
        return {
            routes,
            dataTableItemsPerPage,
            CaosUserSyncMainTable,
            reqData: null,
            installations: [],
            paginatedTotalItems: null,
            loading: false,
        };
    },
    methods: {
        async sendRequest(request) {
            try {
                this.reqData = request;
                this.loading = true;
                let response: FetchInstallationsCaosUserSyncConfigurationResData = await new FetchInstallationsCaosUserSyncConfigurationCommand(request).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    this.installations = response.installationsList;
                    this.paginatedTotalItems = response.totalInstallationsCount;
                }
            } catch (e) {
                console.log("Something went wrong sending FetchInstallationUpdatesStatus request ", e);
            }
            this.loading = false;
        },
        onReload() {
            this.sendRequest(this.reqData);
        },
        async sendRequestAndBackToTheFirstPage(request) {
            this.$refs.standardPage.backToTheFirst();
            this.sendRequest(request);
        },
    },
});
